<template>
  <div class="page-box">
    
    <div class="page-con">
      <div class="login-box plr16">
        <div class="login-title col-f font30">&nbsp;</div>
        <div class="form-box bg-f">
          <div class="form-title col-theme font22">数采采</div>
          <div class="steps-box mt40">
         
            您的数据采录好帮手


          </div>
          <a-button type="primary" size="large" shape="round" @click="login" :disabled="disabled">去登录</a-button>
        </div>
        
       
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import { message } from 'ant-design-vue'
  export default {
    name: "index",
    data() {
      return {
        disabled:true
      }
    },
    created() {
      this.check_token();
      
    },
    methods: {
      ...mapActions([
          'auth_validate'
        ]),
      login(){

          this.$router.push('/login')

      },

      check_token(){
          
          let token = localStorage.getItem('t') || ''

          if (token){
            let params = {}
            
            params.token = token

            this.auth_validate(params)
              .then((dt) => {
                if (dt=="valid"){
                  this.$router.replace('/home')
                  
                }
                else{
                  this.disabled = false
                }
              })
              .catch((dt) => {
                //nothing
                  
                });

              }
         
          else{
              this.disabled = false
          }
          
      }


    }


  };

 


  
  

  


</script>

<style scoped>

.login {
  width:100%;
  padding: 0 20px;
}

</style>
